export const MISMATCH_SCHEDULE_COUNT_EVENT = 'oatrx:mismatch-schedule-review:count';
export const MISMATCH_SCHEDULE_OPEN_EVENT = 'oatrx:mismatch-schedule-review:open';

export const canViewMismatchScheduleReview = ({ profileData }) => (
	String(profileData?.type || '').toLowerCase() === 'pharmacist'
);
